import i18n from 'i18next';
import FetchBackend from 'i18next-fetch-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { initReactI18next } from 'react-i18next';

i18n
    // Use fetch backend
    .use(FetchBackend)
    // Detect user language
    .use(LanguageDetector)
    // Use react
    .use(initReactI18next)
    // Initialize
    .init({
        fallbackLng: 'en',
        ns: "common",
        defaultNS: "common",
        returnObjects: true,
        load: "languageOnly",
        backend: {
            loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json?v=${process.env.REACT_APP_VERSION}`,
            parse: (d: string) => {
                const stripped = d.replace(/\/\/[^\n]*/g, '');
                return JSON.parse(stripped);
            }
        },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"]
        },
        preload: ['en'],
        // debug: process.env.NODE_ENV !== 'production',
        interpolation: {
            escapeValue: false
        }
    })

export default i18n;